import(/* webpackMode: "eager" */ "/vercel/path0/src/components/calculation-selection/product-filter.tsx")